<template>

  <div>
    <my-header> </my-header>
    <div class="mainWrap">
      <div class="main">
        <div class="breadCrumbs">
          <h3>{{odercenter}}</h3>
          <span>
            <router-link to="/">
              <a>首页</a> &gt;
            </router-link>
            <!--  <a @click="product()">产品</a> -->
            <em>{{odercenter}}</em>
          </span>
        </div>
        <!--内容开始-->
        <div class="content">

          <div class="shopp-content">

            <div class="shopping">

              <form id="formOrder"
                    action=""
                    method="post">

                <div class="pay">
                  <h3>支付方式：</h3>
                  <p><input type="radio"
                           name="radio1"
                           checked="checked" /><span>在线支付：</span>  
                           <em v-if="payid==1">支付宝平台的支付方式。如果您已经拥有此平台的账号，可直接使用。</em>
                           <em v-if="payid==2">微信平台的支付方式。请使用微信扫一扫，扫描二维码支付。</em></p>
                  <ul>
                    <li v-for="items in paylist"
                        :key="items.id"                         
                        v-bind:style="{backgroundImage:'url(' + items.backgroundImage + ')'}">
                        <input type="radio"
                             name="pay"
                            :value='items.id'      
                             
                             @click="handlepayid(items.id)" /></li>
                    <!-- <li class="yinlian"><input type="radio"
                  
                             name="pay"
                             value="2" /></li> -->
                    <div class="del_float"></div>
                  </ul>
                </div>

              </form>
              <div class="probuy_list">
                <p class="probuy_three_price"><span>应付总额:</span>
                  ￥{{  DesignallSumPrice|toFixed(2)}}  <s> ￥{{  DesignSumPrice|toFixed(2)}}</s>
                </p>
                <!-- <p class="probuy_three_price"><span>原价:</span>
                
                </p> -->
                <p class="probuy_three_jiesuan">
                  <a @click="payto()">结 算</a>
                </p>
              </div>
            </div>

          </div>

        </div>
        <!--内容结束-->
      </div>
    </div>
  </div>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VDistpicker from "v-distpicker";
import myHeader from "@/views/detailimg";
import { gettjddxx,sjpay ,getsjzfurl,getDoder} from "@/api/api";
export default {
  components: { myHeader, VDistpicker },
  data () {

    return {
        DesignallSumPrice:0,
      odercenter: '结算中心',
      payid: '',
      ukey: 0,
      paylist: [{
        id: 1,
        name: '支付宝',
        backgroundImage: require("../assets/cr_qlpic11.jpg"),
      },
      {
        id: 2,
        name: '微信支付',
        backgroundImage: require("../assets/cr_qlpic12.jpg"),
      }],
      wxpaylist: [
      {
        id: 2,
        name: '微信支付',
        backgroundImage: require("../assets/cr_qlpic12.jpg"),
      }],
      DesignSumPrice: 0,
      weixin: '',
    sjoderid:''

    };
  },

  computed: {
    // Pnumber () {
    //   return this.$store.state.Pnumber;
    // },
    // AllSum () {
    //   return parseFloat(this.$store.state.AllSum);
    // },
    // addinfo () {
    //   return parseFloat(this.$store.state.addinfo);
    // },
    // sum () {
    //   return this.$store.state.sum;
    // },
    // YwwpicRight () {
    //   return this.$store.state.YwwpicRight;
    // },
    // YwwLagre () {
    //   return this.$store.state.YwwLagre;
    // },
    // Xiancai () {
    //   return this.$store.state.Xiancai;
    // },
    // Baozhuang () {
    //   return this.$store.state.Baozhuang;
    // },
    // productname () {
    //   return this.$store.state.productname;
    // },
    // productlist () {
    //   return this.$store.state.productlist;
    // }
  },
  created () {
    // this.DesignSumPrice = this.$route.query.SumPrice
    this.sjoderid=this.$route.query.sjoderid
    window.screenWidth = document.body.clientWidth;
    this.daohang = window.screenWidth > 1024 ? true : false;
    this.getukey();
    this.weixinif();
    // this.getoderdetail()
  },
  mounted () {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;

        this.daohang = window.screenWidth > 1024 ? true : false;
      })();
    };
  },
  methods: {
      getukey () {

      if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      } else {
        this.ukey = localStorage.getItem('newukey')
        
          }
      this.getoderdetail();
    },
        getoderdetail () {
       
      var para = {
          ukey: this.ukey,
       ddbh:this.$route.query.sjoderid
      };

      getDoder(para).then(res => {
        // console.log("DesignSumPrice请求成功", res.data)
      this.DesignallSumPrice = res.data.nr.zhprice
      this.DesignSumPrice = res.data.nr.price
        res => {
          console.info("调用失败", res);
        };
      });
    },
    weixinif () {

      var ua = navigator.userAgent.toLowerCase();

      var isWeixin = ua.indexOf('micromessenger') != -1;

      if (isWeixin == false) {
        this.weixin = 0
      } else {
        this.weixin = 1
         this.paylist=this.wxpaylist
      }
      if (isWeixin) {
        return true;
      } else {
        return false;
      }
    },
    handlepayid (id) {
      this.payid = id;

    },
    payto () {
      if (this.payid == '' || this.payid == undefined) {
        this.$message({
          message: "请选择支付方式",
          type: 'error'
        });
        return;
      }

      if (this.ukey == 0) {
       
         var self = this;
          var para = {
        //    SumPrice:this.DesignallSumPrice ,
           SumPrice:this.DesignallSumPrice ,
            sjoderid:this.sjoderid,
          };
          //   console.log(para);
          getsjzfurl(para).then(res => {
            // console.log("hvgjmh请求成功", res.data);
            alert('请先登录')
              window.location.href =  res.data.url
            res => {
              console.info("调用失败", res);
            };
          });
      } else {
          var self = this;
          var para = {
            token: sessionStorage.getItem('token'),
            pay: this.payid,//支付方式(1:支付宝，3:银联支付)
            iswx: this.weixin,
            price:this.DesignallSumPrice,
             ddbh: this.sjoderid
          };
          sjpay(para).then(res => {
            // console.log("请求成功", res.data);
            if (res.data.error_code == 200) {
                 if (this.payid == 1) {
                window.location.href = res.data.urlxx
            }else if (this.payid == 2){
               if (this.weixin == 1) {
                 window.location.href = res.data.urlxx
                } else{
                      this.$router.push({
                path: '/pay',
                query: {
                  codeurl: res.data.code_url,
                  orderid: this.sjoderid,
                  type:1,
                  DesignSumPrice:this.$Base64.encode(this.DesignallSumPrice ),
                }

              });
               }
            }
            }
           
            res => {
              console.info("调用失败", res);
            };
          });

        }

    },

    //通过点击按钮显示移动端导航
    showdao () {
      this.daohang = !this.daohang;
    },
    //跳转产品页面
    Toproduct () {
      this.$router.push("/");
      if (window.screenWidth < 1024) {
        this.daohang = !this.daohang;
      }
    },
    //跳转设计页面
    ToDesign () {
      this.$router.push("/Design");
    },
    pcdSelect (data) {
      this.message.area.province = data.province.value;
      this.message.area.city = data.city.value;
      this.message.area.dist = data.area.value;
    },
   
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
.distpicker-address-wrapper /deep/ select {
  float: left;
  padding-left: 15px;
  color: #999;
  font-size: 15px;
  padding: 0px;
  font-family: "微软雅黑";
  width: 171px;
  height: 30px;
  background: #252733 no-repeat right 11px;
  /* -webkit-appearance: none; */
  /* resize: none; */
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/DesignPurchase.vue